module.exports = __webpack_public_path__ + "img/icon-error.01614fc4.svg";